import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import { Domain } from '../../domain/domain.model';
import { DomainWebStats } from '../../../kitchen/shared/domain/domain-webstats.model';
import { AdStatsDomainsService } from '../../services/ad-stats-domains.service';
import { GlobalSpinnerService } from '../loader-service/global-spinner.service';
import { SnackBarService } from '../../services/snackbar.service';
@Component({
  selector: 'cm-domain-webstats-dialog',
  template: `
    <div mat-dialog-title>
      <small class="d-block">Webstats:</small>
      <span>{{domain.url}}</span>
    </div>
    <div mat-dialog-content>
      <mat-spinner [color]="'primary'" [mode]="'indeterminate'"
                   [hidden]="!loading"
                   [diameter]="'50'">
      </mat-spinner>
      <div *ngIf="!webstats && !loading">
           No data
      </div>
      <form *ngIf="webstats">
        <div class="webstats-boxes">
          <div class="webstats-box">
            <small>Bounce rate:</small>
            <strong>{{webstats.bounceRate}}</strong>
          </div>
          <div class="webstats-box">
            <small>Visits:</small>
            <strong>{{webstats.visits| number: '1.0-0'}}</strong>
          </div>
          <div class="webstats-box">
            <small>Average visit duration:</small>
            <strong>{{webstats.visitDuration| number: '1.0-0'}} seconds</strong>
          </div>
        </div>
        <div class="webstats-platform" *ngIf="webstats.mobileVisitShare && webstats.desktopVisitShare">
          <div class="platform-header">
            <small>Mobile:</small>
            <strong>{{webstats.mobileVisitShare|percent:'1.2-2'}}</strong>
          </div>
          <div class="platform-header">
            <small>Desktop:</small>
            <strong>{{webstats.desktopVisitShare|percent: '1.2-2'}}</strong>
          </div>
          <div class="platform-compare">
            <div class="platform-mobile" [ngStyle]="{'width': webstats.mobileVisitShare * 100 + '%'}"></div>
            <div class="platform-desktop" [ngStyle]="{'width': webstats.desktopVisitShare * 100 + '%'}"></div>
          </div>
        </div>
        <mat-list class="mat-dialog-data-list">
          <mat-list-item *ngIf="webstats.country1">
            <small class="flex-grow-1">{{webstats.country1}}</small>
            <strong>{{webstats.country1share |percent:'1.2-2'}}</strong>
          </mat-list-item>
          <mat-list-item *ngIf="webstats.country2">
            <small class="flex-grow-1">{{webstats.country2}}</small>
            <strong>{{webstats.country2share |percent:'1.2-2'}}</strong>
          </mat-list-item>
          <mat-list-item *ngIf="webstats.country3">
            <small class="flex-grow-1">{{webstats.country3}}</small>
            <strong>{{webstats.country3share |percent:'1.2-2'}}</strong>
          </mat-list-item>
          <mat-list-item *ngIf="webstats.country4">
            <small class="flex-grow-1">{{webstats.country4}}</small>
            <strong>{{webstats.country4share |percent:'1.2-2'}}</strong>
          </mat-list-item>
          <mat-list-item *ngIf="webstats.country5">
            <small class="flex-grow-1">{{webstats.country5}}</small>
            <strong>{{webstats.country5share |percent:'1.2-2'}}</strong>
          </mat-list-item>
        </mat-list>
      </form>
    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </div>
  `,
  styleUrls: ['./kn-domain-webstats-dialog.component.scss'],
  host: {'class':'mat-dialog-info'}
})
export class KnDomainWebStatsDialogComponent implements OnInit {
  domain: Domain;

  webstats: DomainWebStats;
  loading = true;

  constructor(public dialogRef: MatDialogRef<KnDomainWebStatsDialogComponent>,
              private service: AdStatsDomainsService,
              private gss: GlobalSpinnerService,
              private snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.domain = data.domain;
    this.loading = true;
    this.service.webstats(this.domain).subscribe(next => {
      this.loading = false;
      this.webstats = next;
    }, () => {
      this.loading = false;
    })
  }

  ngOnInit() {
  }

}
